(function addGoogleAnalytics() {
  const head = document.querySelector("head");

  const addProdScript = () => {
    const prodScript = document.createElement("script");

    prodScript.innerHTML = `
        (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
          (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
            m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
        })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

        ga('create', 'UA-41152083-1', 'auto');
        ga('send', 'pageview');
      `;

    head.appendChild(prodScript);
  };

  const addDevScript = () => {
    const devScript = document.createElement("script");

    devScript.innerHTML = `
        (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
          (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
            m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
        })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

        ga('create', 'UA-41152083-4', 'auto');
        ga('send', 'pageview');
    `;

    head.appendChild(devScript);
  };

  const isProduction = () => window.location.href.indexOf("plangrid.com") > -1;

  if (isProduction()) {
    addProdScript();
  } else {
    addDevScript();
  }
})();



// WEBPACK FOOTER //
// ./src/injectGoogleAnalytics.js